import Check from 'icons/lib/checkbox_round_2_48.svg';

import { useTranslation } from '@/i18n/client';
import { Logo } from '@/shared/components/logo';

import styles from './SignUpReasons.module.scss';
import { reasons } from './utils';

export const SignUpReasons = () => {
  const { t } = useTranslation('header');

  return (
    <div className={styles.signUpReasons__container}>
      <h4 className={styles.signUpReasons__title}>
        {t('authModal.reasonsTitle')}
      </h4>
      <Logo className={styles.signUpReasons__logo} />
      <ul className={styles.signUpReasons__list}>
        {reasons.map((reason) => (
          <li key={reason} className={styles['signUpReasons__list--item']}>
            <Check />
            {t(reason)}
          </li>
        ))}
      </ul>
    </div>
  );
};
